/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonalInfoDto } from './personal-info-dto';
import {
    PersonalInfoDtoFromJSON,
    PersonalInfoDtoFromJSONTyped,
    PersonalInfoDtoToJSON,
    PersonalInfoDtoToJSONTyped,
} from './personal-info-dto';
import type { GuestPersonalInfoDto } from './guest-personal-info-dto';
import {
    GuestPersonalInfoDtoFromJSON,
    GuestPersonalInfoDtoFromJSONTyped,
    GuestPersonalInfoDtoToJSON,
    GuestPersonalInfoDtoToJSONTyped,
} from './guest-personal-info-dto';

/**
 * 
 * @export
 * @interface SubmitPersonalInfoRequestDto
 */
export interface SubmitPersonalInfoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SubmitPersonalInfoRequestDto
     */
    idempotenceKey: string;
    /**
     * 
     * @type {PersonalInfoDto}
     * @memberof SubmitPersonalInfoRequestDto
     */
    userPersonalDetails: PersonalInfoDto;
    /**
     * 
     * @type {GuestPersonalInfoDto}
     * @memberof SubmitPersonalInfoRequestDto
     */
    guestPersonalDetails?: GuestPersonalInfoDto | null;
}

/**
 * Check if a given object implements the SubmitPersonalInfoRequestDto interface.
 */
export function instanceOfSubmitPersonalInfoRequestDto(value: object): value is SubmitPersonalInfoRequestDto {
    if (!('idempotenceKey' in value) || value['idempotenceKey'] === undefined) return false;
    if (!('userPersonalDetails' in value) || value['userPersonalDetails'] === undefined) return false;
    return true;
}

export function SubmitPersonalInfoRequestDtoFromJSON(json: any): SubmitPersonalInfoRequestDto {
    return SubmitPersonalInfoRequestDtoFromJSONTyped(json, false);
}

export function SubmitPersonalInfoRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitPersonalInfoRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'idempotenceKey': json['idempotenceKey'],
        'userPersonalDetails': PersonalInfoDtoFromJSON(json['userPersonalDetails']),
        'guestPersonalDetails': json['guestPersonalDetails'] == null ? undefined : GuestPersonalInfoDtoFromJSON(json['guestPersonalDetails']),
    };
}

  export function SubmitPersonalInfoRequestDtoToJSON(json: any): SubmitPersonalInfoRequestDto {
      return SubmitPersonalInfoRequestDtoToJSONTyped(json, false);
  }

  export function SubmitPersonalInfoRequestDtoToJSONTyped(value?: SubmitPersonalInfoRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idempotenceKey': value['idempotenceKey'],
        'userPersonalDetails': PersonalInfoDtoToJSON(value['userPersonalDetails']),
        'guestPersonalDetails': GuestPersonalInfoDtoToJSON(value['guestPersonalDetails']),
    };
}

